const orderApproveApiUrl = {
  // 返回页地址
  returnPage: {
    current: '',
    first: '/first/approval/list',
    review: '/review/approval/list',
    final: '/final/approval/list',
    contract: '/contract/approval/list',
    mortgage: '/mortgage/approval/list',
    forSearch: '/query/list',
    gps: '/gps/approval/list',
    modify: '/approval/order_details/approve/approver/review/'
  },
  modifyPage: '/modify/order_details/modify/approver/review/', // 进入编辑页
  common: {
    encryptionData: '/api/common/encryptionData', // 解密
    getC300VinInfo: '/api/common/getVinModels', // 车300识别车型返回信息
    getC300EvaluationPrice: '/api/common/getChe300AssessPrice', // 车300估价
    getRiskCode: '/api/common/getRiskCodeListByRiskType', // 根据风险类型获取审批意见列表
    calculateMonthPay: '/api/common/calMoney', // 月供计算
    calculateFee: '/api/data/computeLoanInfo' // 费用计算
  },
  base: {
    queryOrderDetail: '/api/caappapproval/findCaApp', // 查询订单详情
    modifyOrderDetail: '/api/caappapproval/approvalEditorOrder', // 保存订单修改
    queryApproverList: '/api/caappapproval/queryFinalApprovalUserList', // 审批人员列表
    saveReplyData: '/api/caappapproval/reApprovalSave/' // 保存批复信息 restful/{appStatus}
  },
  approve: {
    current: null, // 当前审批接口 取值：currentObj['decisionType']
    currentObj: null, // 当前审批接口对象
    cancel: '/api/caappapproval/approvalCancel/', // restful/{appStatus} // 申请单取消
    backToSales: '/api/caappapproval/approvalBackSales/', // restful/{appStatus} // 退回销售补充资料
    // 初审接口
    first: {
      pass: '/api/caappapproval/initApprovalPass',
      refuse: '/api/caappapproval/initApprovalRefuse'
    },
    // 复审接口
    review: {
      pass: '/api/caappapproval/reApprovalPass/', // restful/{appStatus}
      refuse: '/api/caappapproval/reApprovalRefuse',
      backToPrevious: '/api/caappapproval/backApproval/' // restful/{appStatus}
    },
    // 终审接口
    final: {
      pass: '/api/caappapproval/reApprovalPass/', // restful/{appStatus}
      backToPrevious: '/api/caappapproval/backApproval/' // restful/{appStatus}
    },
    // 复议审批接口
    reconsider: {
      pass: '/api/caappapproval/reConsiderPass',
      refuse: '/api/caappapproval/reConsiderRefuse'
    },
    // 签约审批接口
    contract: {
      pass: '/api/caappapproval/signApprovalPass',
      backToPrevious: '/api/caappapproval/backApproval/' // restful/{appStatus}
    },
    // 先放款抵押
    mortgage: {
      loadData: '/api/loanAfter/getMortgageInfoConfirm',
      getSavedScanningCopies: '/api/loanAfter/getLoanAfterInfo',
      saveScanningCopy: '/api/loanAfter/saveScanningData',
      pass: '/api/caappapproval/mortgageApprovalPass',
      back: '/api/caappapproval/mortgageApprovalBack'
    },
    // gps审批接口
    gps: '/api/caappapproval/orderGpsApproval'
  }
}
export {
  orderApproveApiUrl
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.api.js